/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ShowBearingsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-852)">
      <g id="Show-Bearings" transform="matrix(0.542569,0,0,0.571048,169.854,377.398)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1525.62,831.084)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(1.07161,0,0,1.07161,-5.42711,-63.6836)">
          <g transform="matrix(-0.0148712,0.0341128,0.164376,0.0718966,-15.4124,771.499)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.0148712,0.0341128,-0.164376,0.0718966,166.938,771.499)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(1.51843e-18,0.0490619,-0.169714,-0.000233629,196.428,782.221)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(-0.0509369,2.36834e-18,0.000130198,0.0988829,132.769,810.877)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.0509369,2.36303e-18,-0.000129907,0.0986612,18.8062,811.074)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(1.52039e-18,0.0490619,-0.169495,-0.000233328,196.272,811.561)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
        </g>
        <g transform="matrix(1.07161,0,0,1.07161,-5.42717,-63.6836)">
          <g transform="matrix(-0.0509369,2.27961e-18,6.50992e-05,0.0475893,132.848,814.606)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.0509369,2.27961e-18,-6.50992e-05,0.0475893,18.7281,814.606)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(2.99554e-18,-0.0484517,0.0506463,6.97199e-05,21.0502,931.701)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(2.99554e-18,-0.0484517,0.0506463,6.97199e-05,58.5973,931.685)">
            <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
          </g>
          <g transform="matrix(0.278231,2.20597e-32,-6.04729e-32,0.279494,-383.294,590.88)">
            <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'ShowBearingsIcon',
);
